/** @typedef {Record<string, string | Record<string, unknown>>} LocaleTree */
/** @type {LocaleTree} */
const fr = {
  app: {
    defaultDocTitle: "peplies consult - Sports Marketing Consultants",
  },
  nav: {
    about: "À propos",
    hallOfFame: "Hall of Fame",
    services: "Prestations",
    servicesAthletes: "Prestations pour les athlètes",
    servicesCompanies: "Prestations pour les entreprises",
    references: "Références",
    refAthletes: "Références athlètes",
    refCompanies: "Références entreprises",
    press: "Presse",
    campaigns: "Campagnes",
    campaignsPrint: "RP | Print | Affiche",
    campaignsTv: "Spots TV",
    publications: "Publications",
    scientificAdvisoryBoard: "Conseil scientifique",
    toggleMenu: "Basculer le menu de navigation",
  },
  auth: {
    login: "Connexion",
    logout: "Déconnexion",
    password: "Mot de passe",
    passwordPlaceholder: "Saisir le mot de passe",
    wrongPassword: "Mot de passe incorrect",
    showPassword: "Afficher le mot de passe",
    hidePassword: "Masquer le mot de passe",
    notice: "Cette connexion cote client ne protege que la visibilite de navigation et ne constitue pas une authentification securisee.",
    unavailable: "La connexion est indisponible car aucun mot de passe n'est configure.",
  },
  footer: {
    linksHeading: "LIENS",
    about: "À propos",
    services: "Prestations",
    contact: "Contact",
    legal: "Mentions légales",
    privacy: "Politique de confidentialite",
    servicesBlockHeading: "PRESTATIONS",
    servicesAthletes: "Prestations pour les athlètes",
    servicesCompanies: "Prestations pour les entreprises",
    rights: "Tous droits réservés.",
    companyName: "peplies consult GmbH",
    companyStreet: "Höhenstraße 12",
    companyPostalCode: "65321",
    companyCity: "Heidenrod",
    copyrightBrand: "peplies consult - Sports Marketing Consultants",
  },
  intro: {
    title: "À propos",
    p1: 'Nous sommes les « Consultants of Choice » pour les athlètes, clubs, fédérations et entreprises nationaux et internationaux dans le domaine du marketing sportif et du sponsoring sportif.',
    p2: "En tant que société sœur de peplies consult - Marketing Consultants et peplies consult - Executive Consultants, et partenaire de facultés universitaires mondiales de référence en économie du sport, droit du sport et médecine du sport, nous nous engageons à la fois pour la pratique et pour la science.",
    p3: "Nous nous jugeons sur la satisfaction de nos clients et sur notre contribution à l’économie, au sport et à la société.",
    contactCta: "Contact",
  },
  servicesSection: {
    title: "Prestations",
    subtitle: "Aperçu de nos prestations.",
    athletesTitle: "Prestations pour les athlètes",
    athletesBody:
      'Pour nos athlètes, nous proposons – également avec des partenaires et réseaux associés – l’ensemble des mesures d’un accompagnement global au plus haut niveau qualitatif (« programme en 18 points »). Des références internationales étendues existent notamment dans tous les domaines des sports d’hiver (ski alpin, biathlon, saut à ski, combiné nordique, bobsleigh, luge) ainsi que dans le tennis, le golf, l’équitation et l’athlétisme.',
    companiesTitle: "Prestations pour les entreprises",
    companiesBody:
      "Pour les entreprises qui pratiquent déjà le sponsoring sportif, nous proposons des mesures d’analyse, de contrôle et d’optimisation de leurs concepts de sponsoring et des projets correspondants, ainsi que des mesures d’accompagnement ; pour celles qui envisagent d’entrer dans le sponsoring sportif, nous proposons des études de marché et l’élaboration de concepts. Nos prestations comprennent : concepts de sponsoring sportif, études de marché & controlling, mesures d’accompagnement ainsi que scouting et acquisition d’athlètes.",
  },
  clients: {
    title: "Entreprises — commercialisation des droits sportifs / sponsoring sportif",
  },
  contact: {
    docTitle: "peplies consult - Contact",
    modalTitle: "Contact",
    logoAlt: "peplies consult",
    close: "Fermer",
    callUs: "Appelez-nous :",
    writeUs: "Écrivez-nous :",
    mailUs: "Envoyez-nous un e-mail :",
    country: "Allemagne",
    companyName: "peplies consult GmbH",
    street: "Höhenstraße 12",
    postalCode: "65321",
    city: "Heidenrod",
  },
  privacy: {
    docTitle: "peplies consult - Politique de confidentialité",
    title: "Politique de confidentialité",
  },
  legal: {
    docTitle: "peplies consult - Mentions légales",
    title: "Mentions légales",
    tmgaHeading: "Informations conformément au § 5 TMG (Allemagne)",
    country: "Allemagne",
    contact: "Contact",
    vatHeading: "Numéro fiscal / numéro de TVA",
    taxNumberLine: "Numéro fiscal (Steuernummer) 043 241 09523, Finanzamt Wiesbaden II",
    vatIntro: "Numéro d’identification TVA conformément au § 27 a de la loi allemande sur la TVA :",
    managingDirector: "Associé gérant",
    registerHeading: "Inscription au registre du commerce",
    registerCourtLabel: "Tribunal d’enregistrement :",
    registerCourt: "Tribunal local de Wiesbaden (Amtsgericht Wiesbaden)",
    registerNumberLabel: "Numéro d’enregistrement :",
    responsibleHeading: "Responsable du contenu au sens du § 18 MStV (Allemagne) :",
  },
  athletesPage: {
    docTitle: "peplies consult - Athlètes",
    title: "Athlètes actuels",
    subtitle: "Athlètes pour lesquels peplies consult GmbH assume ou a assumé la responsabilité de commercialisation :",
  },
  athleteDetail: {
    docTitle: "peplies consult - Sports Marketing Consultants",
    notFound: "Athlète introuvable",
    birthday: "Date de naissance :",
    discipline: "Discipline :",
    club: "Club :",
    interests: "Centres d’intérêt :",
    profession: "Profession :",
    hobby: "Loisir :",
    achievements: "Palmarès :",
    photoCredit: "Photo : ",
  },
  companyReferences: {
    docTitle: "peplies consult - Entreprises — droits sportifs / sponsoring sportif",
    title: "Entreprises — commercialisation des droits sportifs / sponsoring sportif",
    pageIntro: "Selection d'entreprises qui collaborent ou ont collabore avec peplies consult GmbH:",
    reference: "Référence",
  },
  hallOfFame: {
    docTitle: "peplies consult - Hall of Fame",
    title: "Hall of Fame",
    subtitle:
      '"Legendes du sport" ou projets pour lesquels peplies consult GmbH assumait ou assume la responsabilite de commercialisation:',
    achievementsHeading: "Faits marquants",
    noAchievements: "Aucun palmarès renseigné.",
    flipHint: "Survoler ou appuyer pour retourner",
  },
  press: {
    docTitle: "peplies consult - Presse",
    title: "Presse",
    pageIntro: "Selection de reportages sur peplies consult GmbH:",
    openHint: "Cliquer pour ouvrir",
    unavailable: "Ce document n'est actuellement pas disponible.",
    categories: {
      olympics: "Jeux olympiques",
      magazine: "Magazine",
      news: "Actualités",
    },
  },
  publications: {
    docTitle: "peplies consult - Publications",
    title: "Publications",
    pageIntro: "Publications auxquelles peplies consult GmbH a contribue:",
    isbn: "ISBN",
    openPdf: "Ouvrir le PDF",
    openImage: "Agrandir l'image",
    empty: "Le contenu des publications est en cours de preparation.",
  },
  scientificAdvisoryBoard: {
    docTitle: "peplies consult - Conseil scientifique",
    title: "Conseil scientifique",
    sections: {
      sportsEconomics: {
        title: "Économie du sport",
        members: [
          "Prof. Dr. Herbert Woratschek Université de Bayreuth",
          "Prof. Dr. Michael Wehrheim (décédé) Université de Marburg, European Business School (EBS) Oestrich-Winkel",
          "Prof. Dr. Guido Schafmeister Université Macromedia des médias et de la communication, Munich",
        ],
      },
      sportsMedicine: {
        title: "Médecine du sport/Sciences du sport/Théorie de l'entraînement/Médecine complémentaire",
        members: [
          "Prof. Dr. Dieter Lazik Université de Potsdam, Université du Luxembourg",
          "Prof. Dr. Hartmut Schröder Université Viadrina, Francfort-sur-l'Oder",
          "Dr. Inge Gerding Bad Wildungen",
        ],
      },
    },
  },
  printCampaign: {
    docTitle: "peplies consult - RP, Print, Affiche",
    title: "RP | Print | Affiches",
    empty: "Le materiel de campagne sera bientot publie ici.",
    galleryIntro:
      "Selection de campagnes de communication classiques planifiees et realisees par peplies consult GmbH:",
    imageSectionTitle: "Campagnes image",
    pdfSectionTitle: "Campagnes PDF",
    items: "elements",
    openImage: "Ouvrir l'image :",
    openPdf: "Ouvrir le PDF :",
    openPdfCta: "Ouvrir le PDF dans un nouvel onglet",
  },
  tv: {
    docTitle: "peplies consult - Spots TV",
    title: "Spots TV",
    subtitle:
      "Sélection de campagnes TV planifiées et réalisées par peplies consult GmbH :",
    videoNotSupported: "Votre navigateur ne prend pas en charge la balise vidéo.",
  },
  athleteServices: {
    docTitle: "peplies consult - Prestations pour les athlètes",
    title: "Prestations pour les athlètes",
    intro:
      'Pour nos athlètes, nous proposons – également avec des partenaires et réseaux associés – l’ensemble des mesures d’un accompagnement global au plus haut niveau qualitatif (« programme en 18 points »). Des références internationales étendues existent notamment dans tous les domaines des sports d’hiver (ski alpin, biathlon, saut à ski, combiné nordique, bobsleigh, luge) ainsi que dans le tennis, le golf, l’équitation et l’athlétisme.',
  },
  companyServices: {
    docTitle: "peplies consult - Prestations pour les entreprises",
    title: "Prestations pour les entreprises",
  },
  cookie: {
    message:
      "Nous enregistrons des parametres dans votre navigateur (local storage). Avec « Tout accepter », les videos sont chargees depuis Cloudinary (USA) ; votre adresse IP peut etre transmise. Voir la politique de confidentialite.",
    acceptAll: "Tout accepter",
    acceptNecessary: "Necessaires uniquement",
    decline: "Refuser",
    reopenSettings: "Modifier les parametres cookies",
    externalMediaBlocked:
      "Videos externes desactivees. Utilisez « Modifier les parametres cookies » et « Tout accepter », ou lisez la politique de confidentialite.",
  },
  language: {
    label: "Langue",
    names: {
      de: "Deutsch",
      en: "English",
      fr: "Français",
      es: "Español",
    },
  },
  notFound: {
    docTitle: "peplies consult - Page introuvable",
    message: "La page demandee est introuvable.",
    home: "Retour a l'accueil",
  },
};

export default fr;
